import { useAppStore } from "@/composables";
import { TokenNotValidException } from "@/services/user";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const startupUserCheck = async (_: RouteLocationNormalized, __: RouteLocationNormalized, next: NavigationGuardNext) => {
  try {
    await checkUserOnInitialPageLoad();
    useAppStore().setStartupUserCheckDone();
    next();
  } catch (e: unknown) {
    if (e instanceof TokenNotValidException) {
      useAppStore().setStartupUserCheckDone();
      next(); // Token not valid - let's try to continue with this page
    } else {
      throw e;
    }
  }
};
